
import { Stack, Typography, useTheme } from "@mui/material";
import { ITankTagDisplayValue } from "../tank-cylinder/TankCylinderUtils";
import { DeviceTypesEnum } from "../../common/enums/DeviceTypesEnum";
import { StandaloneTankTATEnum } from "../../common/enums/StandaloneTankTATEnum";
import { LiquidProductionTATEnum } from "../../common/enums/LiquidProductionTATEnum";
import { useMemo } from "react";
import { DeviceSubTypeEnum } from "../../common/enums/DeviceSubTypeEnum";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { getTotalFromFeetAndInchesText } from "../../common/utilities/FeetAndInches";

export type TankTagDisplayValueV2Props = {
    deviceType: DeviceTypesEnum,
    deviceSubType: DeviceSubTypeEnum,
    dualPhase: boolean,
    tagValues: ITankTagDisplayValue[]
}

export default function TankTagDisplayValueV2({
    deviceType,
    deviceSubType,
    dualPhase,
    tagValues
} : TankTagDisplayValueV2Props) {


    const [userState] = useUserContext();

    const theme = useTheme();

    const values = useMemo(() => { 

        // const dualPhase = deviceType === DeviceTypesEnum.InternalTank &&
        //                     tagValues.find(o => o.tatID === LiquidProductionTATEnum.InterfaceLevel);

        const topLevel = tagValues.find(o => deviceType === DeviceTypesEnum.InternalTank ? 
                                        o.tatID === LiquidProductionTATEnum.TopLevel : 
                                        o.tatID === StandaloneTankTATEnum.LiquidHeight);

        const stock = tagValues.find(o => deviceType === DeviceTypesEnum.InternalTank ?
                                    (dualPhase || deviceSubType === DeviceSubTypeEnum.Oil) ?
                                    o.tatID === LiquidProductionTATEnum.OilStock :
                                    o.tatID === LiquidProductionTATEnum.WaterStock :
                                    o.tatID === StandaloneTankTATEnum.LiquidStock);


        let interfaceLevel: ITankTagDisplayValue | undefined = undefined;
        let waterStock: ITankTagDisplayValue | undefined = undefined;
        if (dualPhase) {
    
            interfaceLevel = tagValues.find(o => o.tatID === LiquidProductionTATEnum.InterfaceLevel);
            waterStock = tagValues.find(o => o.tatID ===  LiquidProductionTATEnum.WaterStock);
        }

        return {
            topLevel,
            stock,
            interfaceLevel,
            waterStock,
        };
    }, [
        tagValues,
        deviceType,
        deviceSubType,
        dualPhase
    ]);

    function renderRow(value1: ITankTagDisplayValue | undefined, value2: ITankTagDisplayValue | undefined) {
        return (
            <Stack
                direction='row'
                sx={{
                    justifyContent: 'space-between',
                    marginLeft: 'auto!important',
                    marginRight:'auto!important',

                    '&+&': {
                        marginTop: 1,
                    }
                }}>
                {value1 && <Stack direction='column' sx={{
                    marginRight: 2
                }}>
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            minWidth: 110
                        }}>{value1.name}</Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 600,
                            padding: 1,
                            minWidth: 110,
                            borderColor: theme.palette.grey[600],
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            whiteSpace: 'nowrap'
                        }}>
                            {value1.value}
                    </Typography>
                </Stack>
                }
                {value2 && 
                <Stack direction='column'>
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            minWidth: 110
                        }}>{value2.name}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            textAlign: 'center',
                            fontWeight: 600,
                            padding: 1,
                            borderColor: theme.palette.grey[600],
                            minWidth: 110,
                            borderWidth: '1px',
                            borderStyle: 'solid',
                            whiteSpace: 'nowrap'
                        }}>

                        {userState.userSettings?.tankLevelInches ? `${getTotalFromFeetAndInchesText(value2.value)} Inches` : value2.value}
                    </Typography>
                </Stack>
                }
            </Stack>
        );
    }

    return (
        <Stack 
            direction='column' 
            sx={{
                marginLeft: 'auto!important',
                marginRight:'auto!important',
            }}
        >
            {
                renderRow(values.stock, values.topLevel)
            }
            {
                renderRow(values.waterStock, values.interfaceLevel)
            }
        </Stack>
    );
}
